import type { CSSObject, Theme } from '@mui/material'
import type { ReportStatus } from 'features/yieldbirdWrapperAgent/api/types'

export const selectReportStatusColor = (
  status: ReportStatus,
  theme: Theme,
): CSSObject['backgroundColor'] => {
  switch (status) {
    case 'consent-blocked-direct':
    case 'consent-blocked-proxied':
    case 'dead-lettered':
    case 'timed-out':
      return theme.palette.error.main
    case 'failed':
    case 'queued':
    case 'running':
      return theme.palette.warning.main
    case 'succeeded':
      return theme.palette.success.main
  }
}
